module.exports = "/_next/static/images/5d1e3108ef7256c33d07c0e5fcaa0562-woman-with-iphone@1x.jpg";